<template>
  <div class="flex flex-col w-full h-full gap-2">
    <span class="subtitle-bold section">בחירת תגיות ללקוח</span>
    <AutoComplete
      v-model="tags"
      style="width: 100%"
      multiple
      class="pb-4 "
      :suggestions="items"
      @complete="search"
    />

    <drawer-footer
      :approveDisable="loading"
      :approveLoading="loading"
      @approve-click="clickCTA"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { CustomersApi } from '@app/api/admin';
import { useAdminClientsStore } from '@app/stores';
import { trackEvent } from '@app/composables/posthog';

const emit = defineEmits(['close']);

const route = useRoute();
const adminClientsStore = useAdminClientsStore();

const clientId = route.params.id as string;
const loading = ref(false);
const tags = ref<string[]>([]);
const suggestions = ref<string[]>([]);
const items = ref<string[]>([]);

const getTagsAndSuggestions = () => {
  CustomersApi.fetchTagsAndSuggestions(clientId)
    .then((response) => {
      tags.value = response.tags;
      suggestions.value = response.suggestions;
      items.value = response.suggestions;
    });
};

const search = (event: any) => {
  items.value = [...suggestions.value.filter(item => item.includes(event.query) && !tags.value.includes(item)), event.query];
};

const clickCTA = (): void => {
  trackEvent('customer_tags_updated');
  loading.value = true;
  CustomersApi.addTagsToClient(clientId, tags.value)
    .then(() => {
      // Tags show on the customers list cards — drop the cached list so it refetches.
      adminClientsStore.resetCustomersList();
      emit('close');
    });
};

onMounted(() => {
  getTagsAndSuggestions();
})
</script>
